import type { Components, Theme } from '@mui/material/styles';

export const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: {
    '#nprogress': {
      pointerEvents: 'none',
    },

    '#nprogress .bar': {
      height: 3,
      left: 0,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000,
      backgroundColor: 'var(--mui-palette-primary-main)',
    },

    '.cky-btn-revisit-wrapper': {
      display: 'none !important',
    },
  },
};
